var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "funnel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.378,
    height: 10.222,
    viewBox: "0 0 10.378 10.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28635",
    "data-name": "Group 28635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65822",
    "data-name": "Path 65822",
    d: "M10.378,3.486a.569.569,0,0,0-.569-.569H.569a.569.569,0,0,0-.465.9l3.35,4.763.009,3.465a1.1,1.1,0,0,0,1.711.913l1.2-.8a1.137,1.137,0,0,0,.506-.952L6.866,8.6l3.407-4.781A.569.569,0,0,0,10.378,3.486Z",
    transform: "translate(0 -2.917)",
    fill: "#263757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.153e1608b9f88c055894410b96d0eeea.svg";
export { ForwardRef as ReactComponent };